import React, { Component } from 'react'
import { Link } from 'react-router'
import classnames from 'classnames'
import styles from './styles/button.scss'

export default class LinkButton extends Component {
  render() {
    const { to, text, style = {}, disabled = false } = this.props

    if (disabled) {
      return (
        <span className={classnames(styles.button, styles.disabled)} style={style}>
          {text}
        </span>
      )
    } else {
      return (
        <Link to={to} className={styles.button} style={style}>
          {text}
        </Link>
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/LinkButton.js